<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { ddStore } from "@common/ddStore";

let vmsCustomAttributeManagerConfig = {
    cId: "vmsCustomAttributeManager",
    cType: "vmsCustomAttributeManager",
    cTitle: "User Defined Fields",
    cTemplate: `<div :id="wrapperID" class="vmsCustomAttributeManager-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div class="vmsCustomAttributeManager-title">User Defined Fields</div>
                    <div class="vmsCustomAttributeManager-mainWrapper">
                        <span>Record Type:</span>
                        <div class="vmsCustomAttributeManager-recordType">
                            <control name="CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE" :items="pspList" @update:value="getCustomAttributeGroups"></control>
                        </div>
                    </div>
                    <div class="vmsCustomAttributeManager-Wrapper">
                        <div class="vmsCustomAttributeManager-mainWrapper __marginRight">
                            <div class="vmsCustomAttributeManager-groupList-header">
                                <span>{{currentPspTitle() ?? 'Groups'}}</span>
                            </div>
                            <div>
                                <control name="CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_GROUP_SEARCH" @update:value="groupFilter"></control>
                            </div>
                            <div>
                                <div v-if="!groupList.length" class="vmsCustomAttributeManager-groupList-control __empty">
                                    <span>Click New to create a user defined field group.</span>
                                </div>
                                <div v-else-if="groupList.length && isGroupFiltering() && !filterGroupList.length" class="vmsCustomAttributeManager-groupList-control __empty">
                                    <span>No results found for your search</span>
                                </div>
                                <control v-else name="GROUP_LIST" :items="isGroupFiltering() ? filterGroupList : groupList" class="vmsCustomAttributeManager-groupList-control"></control>
                            </div>
                            <div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_NEW_GROUP_BUTTON"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_EDIT_GROUP_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_DELETE_GROUP_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                </div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_MOVE_UP_GROUP_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_MOVE_DOWN_GROUP_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_COPY_GROUP_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                </div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_ALPHABETIZE_GROUP_BUTTON"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_IMPORT_GROUP_BUTTON"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_EXPORT_GROUP_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vmsCustomAttributeManager-mainWrapper __marginLeft">
                            <div class="vmsCustomAttributeManager-attrList-header">
                                <control name="CUSTOM_ATTRIBUTE_MANAGER_SELECT_ALL_ATTRS" class="selectAll" :value="isAllSelectedAttr()"></control>
                                <span>Group Components</span>
                            </div>
                            <div>
                                <control name="CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_ATTR_SEARCH" @update:value="attrFilter"></control>
                            </div>
                            <div>
                                <div v-if="!currentGroupId" class="vmsCustomAttributeManager-attrList-control __empty">
                                    <span>Please select a group from the list to the left.</span>
                                </div>
                                <div v-else-if="attrList.length && isAttrFiltering() && !filterAttrList.length" class="vmsCustomAttributeManager-attrList-control __empty">
                                    <span>No results found for your search</span>
                                </div>
                                <control v-else name="ATTR_LIST" :items="isAttrFiltering() ? filterAttrList : attrList" class="vmsCustomAttributeManager-attrList-control"></control>
                            </div>
                            <div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_NEW_ATTR_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_EDIT_ATTR_BUTTON" :disabled="!currentGroupId || currentAttrIds.length !== 1"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_DELETE_ATTR_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                </div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_MOVE_UP_ATTR_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_MOVE_DOWN_ATTR_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_COPY_ATTR_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                </div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_ALPHABETIZE_ATTR_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_IMPORT_ATTR_BUTTON" :disabled="!currentGroupId"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_EXPORT_ATTR_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                </div>
                                <div class="vmsCustomAttributeManager-buttons">
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_CHANGE_ATTR_GROUP_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                    <div class="vmsCustomAttributeManager-button __control">
                                        <control name="CUSTOM_ATTRIBUTE_MANAGER_USAGE_REPORT_ATTR_BUTTON" :disabled="!currentGroupId || !currentAttrIds.length"></control>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="vmsCustomAttributeManager-buttons">
                        <div class="vmsCustomAttributeManager-button"><control name="CUSTOM_ATTRIBUTE_MANAGER_OK_BUTTON"></control></div>
                        <div class="vmsCustomAttributeManager-button"><control name="CUSTOM_ATTRIBUTE_MANAGER_CANCEL_BUTTON"></control></div>
                    </div>
                    <div class="vmsCustomAttributeManager-inputUploadFiles">
                        <input ref="vmsCustomAttributeManagerImportGroupFile" type="file" accept=".json,.csv" @change="uploadFileImportGroup"/>
                        <input ref="vmsCustomAttributeManagerImportAttrsFile" type="file" accept=".json,.csv" @change="uploadFileImportAttrs"/>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE',
            type: 'dropdown',
            hideMessage: true,
            showClearButton: false,
            fields: { text: 'text', value: 'value' },
            ref: 'vmsCustomAttributeManagerPerspective'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_SELECT_ALL_ATTRS',
            type: 'checkbox',
            onchange: 'selectAllAttr',
            ref: 'vmsCustomAttributeManagerSelectAllAttrs'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_GROUP_SEARCH',
            type: 'string',
            hideMessage: true,
            showClearButton: true,
            fields: { text: 'text', value: 'value' },
            isNotDDPlaceholder: true,
            placeholder: 'Enter name for search',
            ref: 'vmsCustomAttributeManagerGroupSearch'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_ATTR_SEARCH',
            type: 'string',
            hideMessage: true,
            showClearButton: true,
            isNotDDPlaceholder: true,
            placeholder: 'Enter name for search',
            fields: { text: 'text', value: 'value' },
            ref: 'vmsCustomAttributeManagerAttrSearch'
        },
        {
            name: 'GROUP_LIST',
            type: 'list',
            onclick: 'selectGroup',
            itemContentTemplate: `
                <div class="vmsCustomAttributeManager-itemList">
                    <div class="vmsCustomAttributeManager-itemList-cell">
                        <div class="vmsCustomAttributeManager-itemList-cell-whiteSpace">
                            <div v-if="component.currentGroupId === data.groupID" class="vmsCustomAttributeManager-itemList-cell-isActive"></div>
                        </div>
                        {{data.groupName}}
                        <span v-if="component.clientIsAdminOrStaff" class="vmsCustomAttributeManager-itemId">&nbsp;(#{{data.groupID}})</span>
                    </div>
                </div>
                `
        },
        {
            name: 'ATTR_LIST',
            type: 'list',
            onclick: 'selectAttr',
            itemContentTemplate: `
                <div class="vmsCustomAttributeManager-itemList">
                    <div class="vmsCustomAttributeManager-itemList-cell">
                        <div class="vmsCustomAttributeManager-itemList-cell-whiteSpace">
                            <ejs-checkbox :checked="component.currentAttrIds.indexOf(data.attrID) !== -1"></ejs-checkbox>
                        </div>
                        {{data.attrName}}
                        <span v-if="component.clientIsAdminOrStaff" class="vmsCustomAttributeManager-itemId">&nbsp;(#{{data.attrID}})</span>
                    </div>
                </div>
                `
        },
        // group's buttons
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_NEW_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_NEW',
            action: 'newGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_EDIT_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_EDIT',
            action: 'editGroup',
            onclick: '',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_DELETE_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_DELETE',
            action: 'deleteGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_MOVE_UP_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_MOVE_UP',
            action: 'moveUpGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_COPY_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_COPY',
            action: 'copyGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_MOVE_DOWN_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_MOVE_DOWN',
            action: 'moveDownGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_IMPORT_GROUP_BUTTON',
            type: 'button',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_BUTTON_IMPORT',
            action: 'importGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_EXPORT_GROUP_BUTTON',
            type: 'button',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_BUTTON_EXPORT',
            action: 'exportGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_ALPHABETIZE_GROUP_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_ALPHABETIZE',
            action: 'alphabetizeGroups',
            onclick: 'doAction',
        },
        // attr's buttons
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_NEW_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_NEW',
            action: 'newAttr',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_EDIT_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_EDIT',
            action: 'editAttr',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_DELETE_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_DELETE',
            action: 'deleteAttr',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_MOVE_UP_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_MOVE_UP',
            action: 'moveUpAttrs',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_COPY_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_COPY',
            action: 'copyAttr',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_MOVE_DOWN_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_MOVE_DOWN',
            action: 'moveDownAttrs',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_IMPORT_ATTR_BUTTON',
            type: 'button',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_BUTTON_IMPORT_ATTR',
            action: 'importAttrs',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_EXPORT_ATTR_BUTTON',
            type: 'button',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_BUTTON_EXPORT_ATTR',
            action: 'exportAttrs',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_ALPHABETIZE_ATTR_BUTTON',
            type: 'button',
            label: 'DD.COMMON.BUTTON_ALPHABETIZE',
            action: 'alphabetizeAttrs',
            onclick: "doAction",
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_CHANGE_ATTR_GROUP_BUTTON',
            type: 'button',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_BUTTON_CHANGE_GROUP',
            action: 'changeAttrsGroup',
            onclick: 'doAction',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_USAGE_REPORT_ATTR_BUTTON',
            type: 'button',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_BUTTON_USAGE_REPORT',
            action: 'usageReportAttr',
            onclick: 'doAction',
        },
        // bottom buttons
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close',
        },
    ]
};

let vmsCustomAttributeManagerCmp = {
    name: 'vmsCustomAttributeManager',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        }
    },
    data() {
        return {
            pspList: [],
            currentGroupId: null,
            currentAttrIds: [],
            groupList: [],
            attrList: [],
            filterGroupList: [],
            filterAttrList: [],
            uploadMaxFilesize: 10, // in MB
        };
    },
    computed: {
        clientIsAdminOrStaff() {
            if (
                typeof this.userStore.coordinator === 'undefined'
                || (
                    typeof this.userStore.coordinator.CLIENT_IS_ADMIN === 'undefined'
                    && typeof this.userStore.coordinator.CLIENT_IS_STAFF === 'undefined'
                )
            ) {
                return false;
            }
            return this.userStore.coordinator.CLIENT_IS_ADMIN === 'Yes' || this.userStore.coordinator.CLIENT_IS_STAFF === 'Yes';
        },
        wrapperID() {
            return this.cId + 'Wrapper';
        },
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        currentPsp() {
            if (typeof this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE'] === 'undefined') {
                return null;
            }
            return this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE'].value;
        },
        currentPspTitle() {
            if (
                typeof this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE'] !== 'undefined'
                && this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE'].value
            ) {
                let pspId = this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE'].value;
                return this.pspList.find((item) => item.value === pspId)?.text ?? null;
            }
            return null;
        },
        isAllSelectedAttr() {
            let attrList = this.isAttrFiltering() ? this.filterAttrList : this.attrList;
            if (!attrList.length || !this.currentAttrIds.length || attrList.length !== this.currentAttrIds.length) {
                return false;
            }
            for (let i = 0; i < attrList.length; i++) {
                if (this.currentAttrIds.indexOf(attrList[i].attrID) === -1) {
                    return false;
                }
            }
            return true;
        },
        isGroupFiltering() {
            if (typeof this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_GROUP_SEARCH'] === 'undefined') {
                return false;
            }
            return this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_GROUP_SEARCH'].value.length > 2;
        },
        isAttrFiltering() {
            if (typeof this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_ATTR_SEARCH'] === 'undefined') {
                return false;
            }
            return this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_ATTR_SEARCH'].value.length > 2;
        },
        groupFilter() {
            if (!this.isGroupFiltering()) {
                this.filterGroupList = [];
                return;
            }
            let searchText = this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_GROUP_SEARCH'].value.toLowerCase().trim();
            this.filterGroupList = this.groupList.filter((item) => item.groupName.toLowerCase().includes(searchText));
            if (this.currentGroupId && this.filterGroupList.indexOf(this.currentGroupId) === -1) {
                this.currentGroupId = null;
            }
        },
        attrFilter() {
            if (!this.isAttrFiltering()) {
                this.filterAttrList = [];
                return;
            }
            let searchText = this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE_ATTR_SEARCH'].value.toLowerCase().trim();
            this.filterAttrList = this.attrList.filter((item) => item.attrName.toLowerCase().includes(searchText));
        },
        onLoad() {
            this.$emit('update:vmsCustomAttributeManagerLoaded', true);
            library.showLoadingIndicator(this.wrapperID);
            this.sDs.post('ec_getAvailablePerspectivesCustomAttribute').then((response) => {
                library.hideLoadingIndicator(this.wrapperID);
                if (response && response.status === 'success' && typeof response.data === 'object' && response.data && response.data.length) {
                    let tmpPspList = [];
                    response.data.forEach((item) => {
                        tmpPspList.push({
                            text: item.pspTitle,
                            value: item.pspID
                        });
                    });
                    this.pspList = library.cloneObj(tmpPspList);
                    this.controls['CUSTOM_ATTRIBUTE_MANAGER_PERSPECTIVE'].value = response.data[0].pspID;
                    this.getCustomAttributeGroups();
                }
            });
        },
        async selectGroup(groupInfo) {
            this.currentGroupId = groupInfo.groupID;
            await this.getCustomAttributes();
        },
        async selectAttr(attrInfo) {
            let index = this.currentAttrIds.indexOf(attrInfo.attrID);
            if (index !== -1) {
                this.currentAttrIds.splice(index, 1);
            } else {
                this.currentAttrIds.push(attrInfo.attrID);
            }
        },
        selectAllAttr(event) {
            if (event.checked) {
                let tmpCurrentAttrIds = [];
                if (this.isAttrFiltering()) {
                    this.filterAttrList.forEach((item) => tmpCurrentAttrIds.push(item.attrID));
                } else {
                    this.attrList.forEach((item) => tmpCurrentAttrIds.push(item.attrID));
                }
                this.currentAttrIds = tmpCurrentAttrIds;
            } else {
                this.currentAttrIds = [];
            }
        },
        async doAction(event, control) {
            let action = control && typeof control.action !== 'undefined' ? control.action : null;
            if (action === 'alphabetizeGroups') {
                this.groupList = [...this.groupList].sort((lhs, rhs) => lhs.groupName.localeCompare(rhs.groupName));
            } else if (action === 'alphabetizeAttrs') {
                this.attrList = [...this.attrList].sort((lhs, rhs) => lhs.attrName.localeCompare(rhs.attrName));
            } else if (action === 'moveUpGroup' && this.currentGroupId) {
                let currentGroupId = this.currentGroupId;
                let tmpGroupList = this.groupList;
                let index = tmpGroupList.findIndex((group) => group.groupID === currentGroupId);
                if (index > 0) {
                    [tmpGroupList[index - 1], tmpGroupList[index]] = [tmpGroupList[index], tmpGroupList[index - 1]];
                    this.groupList = library.cloneObj(tmpGroupList);
                }
            } else if (action === 'moveDownGroup' && this.currentGroupId) {
                let currentGroupId = this.currentGroupId;
                let tmpGroupList = this.groupList;
                let index = tmpGroupList.findIndex((group) => group.groupID === currentGroupId);
                if (index < tmpGroupList.length - 1) {
                    [tmpGroupList[index], tmpGroupList[index + 1]] = [tmpGroupList[index + 1], tmpGroupList[index]];
                    this.groupList = library.cloneObj(tmpGroupList);
                }
            } else if (action === 'moveUpAttrs' && this.currentAttrIds.length) {
                let currentAttrIds = this.currentAttrIds;
                let tmpAttrList = this.attrList;
                let indexes = [];
                for (let i = 0; i < currentAttrIds.length; i++) {
                    let attrId = currentAttrIds[i];
                    let index = tmpAttrList.findIndex((attr) => attr.attrID === attrId);
                    if (index !== -1) {
                        indexes[index] = attrId;
                    }
                }
                indexes = Object.entries(indexes).sort(([lhs], [rhs]) => lhs - rhs);
                currentAttrIds = Object.values(indexes).map(([, value]) => Number(value));
                indexes = Object.values(indexes).map(([key]) => Number(key));
                for (let i = 0; i < currentAttrIds.length; i++) {
                    let attrId = currentAttrIds[i];
                    let index = tmpAttrList.findIndex((attr) => attr.attrID === attrId);
                    if (index !== -1 && index > 0 && !indexes.includes(index - 1)) {
                        indexes[i] = null;
                        [tmpAttrList[index - 1], tmpAttrList[index]] = [tmpAttrList[index], tmpAttrList[index - 1]];
                    }
                }
                this.attrList = library.cloneObj(tmpAttrList);
            } else if (action === 'moveDownAttrs' && this.currentAttrIds.length) {
                let currentAttrIds = this.currentAttrIds;
                let tmpAttrList = this.attrList;
                let indexes = [];
                for (let i = 0; i < currentAttrIds.length; i++) {
                    let attrId = currentAttrIds[i];
                    let index = tmpAttrList.findIndex((attr) => attr.attrID === attrId);
                    if (index !== -1) {
                        indexes[index] = currentAttrIds[i];
                    }
                }
                indexes = Object.entries(indexes).sort(([lhs], [rhs]) => rhs - lhs);
                currentAttrIds = Object.values(indexes).map(([, value]) => Number(value));
                indexes = Object.values(indexes).map(([key]) => Number(key));
                for (let i = 0; i < currentAttrIds.length; i++) {
                    let attrId = currentAttrIds[i];
                    let index = tmpAttrList.findIndex((attr) => attr.attrID === attrId);
                    if (index !== -1 && index < tmpAttrList.length - 1 && !indexes.includes(index + 1)) {
                        indexes[i] = null;
                        [tmpAttrList[index], tmpAttrList[index + 1]] = [tmpAttrList[index + 1], tmpAttrList[index]];
                    }
                }
                this.attrList = library.cloneObj(tmpAttrList);
            } else if (action === 'deleteGroup' && this.currentGroupId) {
                library.showLoadingIndicator(this.wrapperID);
                let pspId = this.currentPsp();
                let groupId = this.currentGroupId;
                let dependencies = await this.getCustomAttributeDependencies(pspId, groupId);
                if (dependencies) {
                    let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                    let message = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_GROUP_USED_IN_PLACES', [dependencies]);
                    library.hideLoadingIndicator(this.wrapperID);
                    await library.showDialog(message, false, false, {
                        title: title, name: 'vmsCustomAttributeManagerDeleteGroupWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                } else {
                    let dialogSuccessFn = async () => {
                        if (await this.deleteCustomAttributeGroup(pspId, groupId)) {
                            this.currentGroupId = null;
                            await this.getCustomAttributeGroups(true);
                        }
                    };
                    let title = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_CONF_DEL_ATTR_MULTI_TITLE');
                    let message = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_DEL_GROUP');
                    let groupName = this.groupList.find((item) => item.groupID === groupId)?.groupName;
                    message += `<div>${groupName}` + (this.clientIsAdminOrStaff ? `<span class='vmsCustomAttributeManager-itemId'>&nbsp;(#${groupId})</span>` : ``) + `?</div>`;
                    library.hideLoadingIndicator(this.wrapperID);
                    await library.showDialog(message, dialogSuccessFn, false, {
                        title: title, name: 'vmsCustomAttributeManagerDeleteGroupDialog', preventCloseOnBackdropClick: true
                    });
                }
            } else if (action === 'deleteAttr' && this.currentGroupId && this.currentAttrIds.length) {
                library.showLoadingIndicator(this.wrapperID);
                let pspId = this.currentPsp();
                let groupId = this.currentGroupId;
                let currentAttrIds = this.currentAttrIds;
                let attrNames = [];
                let dependencies = await this.getCustomAttributeDependencies(pspId, groupId, currentAttrIds);
                if (dependencies) {
                    let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                    let message = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_USED_IN_PLACES', [dependencies]);
                    library.hideLoadingIndicator(this.wrapperID);
                    await library.showDialog(message, false, false, {
                        title: title, name: 'vmsCustomAttributeManagerDeleteAttrWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                } else {
                    let dialogSuccessFn = async () => {
                        if (await this.deleteCustomAttributes(pspId, groupId, currentAttrIds)) {
                            this.currentAttrIds = [];
                            await this.getCustomAttributes();
                        }
                    };
                    currentAttrIds.forEach((attrId) => {
                        let attrName = this.attrList.find((item) => item.attrID === attrId)?.attrName;
                        if (attrName) {
                            attrNames.push(`<div>${attrName}` + (this.clientIsAdminOrStaff ? `<span class='vmsCustomAttributeManager-itemId'>&nbsp;(#${attrId})</span>` : ``) + `</div>`);
                        }
                    });
                    let title = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_CONF_DEL_ATTR_MULTI_TITLE');
                    let message = await ddStore.getAlias('CUSTOM_ATTRIBUTE', 'CUSTOMATTRIBUTEMANAGER_CONF_DEL_ATTR_MULTI', [attrNames.join('')]);
                    library.hideLoadingIndicator(this.wrapperID);
                    await library.showDialog(message, dialogSuccessFn, false, {
                        title: title, name: 'vmsCustomAttributeManagerDeleteAttrDialog', preventCloseOnBackdropClick: true
                    });
                }
            } else if (action === 'changeAttrsGroup' && this.currentGroupId && this.currentAttrIds.length) {
                let attrGroupId = this.currentGroupId;
                let groupList = this.groupList;
                let attrIds = this.currentAttrIds;
                let listTitle = this.currentPspTitle();
                let changeCallback = async () => {
                    await this.getCustomAttributes();
                    this.currentAttrIds = [];
                };
                actionStore.openCustomAttributeChangeGroup(
                    attrGroupId, groupList, attrIds, listTitle, changeCallback
                );
            } else if (action === 'usageReportAttr' && this.currentGroupId && this.currentAttrIds.length) {
                library.showLoadingIndicator(this.wrapperID);
                let pspId = this.currentPsp();
                let groupId = this.currentGroupId;
                let currentAttrIds = this.currentAttrIds;
                let dependencies = await this.getCustomAttributeDependencies(pspId, groupId, currentAttrIds);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                let message = await ddStore.getAlias(
                    'CUSTOM_ATTRIBUTE', dependencies ? 'CUSTOMATTRIBUTEMANAGER_USED_REPORT' : 'CUSTOMATTRIBUTEMANAGER_NOT_USED_REPORT', [dependencies]
                );
                await library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeManagerUsageReportDialog', preventCloseOnBackdropClick: true, showAsAlert: true
                });
                library.hideLoadingIndicator(this.wrapperID);
            } else if (action === 'exportGroup' && this.currentGroupId) {
                library.showLoadingIndicator(this.wrapperID);
                let pspId = this.currentPsp();
                let groupId = this.currentGroupId;
                let fileName = this.groupList.find((item) => item.groupID === groupId)?.groupName;
                let response = await this.exportCustomAttributeGroups(pspId, groupId, fileName);
                if (response && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsCustomAttributeManagerExportWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                }
                library.hideLoadingIndicator(this.wrapperID);
            } else if (action === 'importGroup') {
                this.$refs.vmsCustomAttributeManagerImportGroupFile.click();
            } else if (action === 'exportAttrs' && this.currentGroupId && this.currentAttrIds.length) {
                library.showLoadingIndicator(this.wrapperID);
                let pspId = this.currentPsp();
                let groupId = this.currentGroupId;
                let fileName = this.groupList.find((item) => item.groupID === groupId)?.groupName;
                let currentAttrIds = this.currentAttrIds;
                if (currentAttrIds.length === 1) {
                    fileName = this.attrList.find((item) => item.attrID === currentAttrIds[0])?.attrName;
                }
                let response = await this.exportCustomAttributes(pspId, groupId, fileName, currentAttrIds);
                if (response && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsCustomAttributeManagerExportWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                }
                library.hideLoadingIndicator(this.wrapperID);
            } else if (action === 'importAttrs') {
                this.$refs.vmsCustomAttributeManagerImportAttrsFile.click();
            } else if (action === 'newGroup' && this.currentPsp()) {
                if (this.currentPsp() === 14) {
                    // PROFESSION
                } else if (this.currentPsp() === 15) {
                    // CREDENTIAL
                } else {
                    // other
                }
            } else if (action === 'editGroup' && this.currentPsp()) {
                if (this.currentPsp() === 14) {
                    // PROFESSION
                } else if (this.currentPsp() === 15) {
                    // CREDENTIAL
                } else {
                    // other
                }
            } else if (action === 'copyGroup' && this.currentGroupId) {
                library.showLoadingIndicator(this.wrapperID);
                let currentGroupId = this.currentGroupId;
                let response = await this.copyCustomAttributeGroup(currentGroupId);
                if (response && response.status === 'success' && typeof response.data !== 'undefined') {
                    await this.getCustomAttributeGroups();
                    this.currentGroupId = currentGroupId;
                } else if (response && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsCustomAttributeManagerCopyWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                }
                library.hideLoadingIndicator(this.wrapperID);
            } else if (action === 'copyAttr' && this.currentGroupId && this.currentAttrIds.length) {
                library.showLoadingIndicator(this.wrapperID);
                let currentGroupId = this.currentGroupId;
                let currentAttrIds = this.currentAttrIds;
                let response = await this.copyCustomAttributes(currentGroupId, currentAttrIds);
                if (response && response.status === 'success' && typeof response.data !== 'undefined') {
                    await this.getCustomAttributes();
                } else if (response && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsCustomAttributeManagerCopyWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                }
                library.hideLoadingIndicator(this.wrapperID);
            }
        },
        async uploadFileImportGroup(event) {
            if (typeof event === 'undefined' || !event || !this.currentPsp()) {
                return;
            }
            let files = event.target.files;
            if (!files.length) {
                return;
            }
            library.showLoadingIndicator(this.wrapperID);
            if (files.length > 1) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                let message = 'Select no more than one file.';
                await library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeManagerImportError', preventCloseOnBackdropClick: true
                });
                library.hideLoadingIndicator(this.wrapperID);
                return;
            }
            if (files[0].size > (this.uploadMaxFilesize * 1024 * 1024)) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                let message = `The maximum file size limit is ${this.uploadMaxFilesize} Mb.`;
                await library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeManagerImportError', preventCloseOnBackdropClick: true
                });
                library.hideLoadingIndicator(this.wrapperID);
                return;
            }
            let file = files[0];
            let fileReader = new FileReader();
            let fileType = files[0].type === 'application/json' ? 'json' : 'csv';
            fileReader.onload = ((e) => {
                let content = e.target.result;
                this.importCustomAttributeGroups(content, fileType);
            });
            fileReader.readAsText(file);
        },
        async uploadFileImportAttrs(event) {
            if (typeof event === 'undefined' || !event || !this.currentPsp()) {
                return;
            }
            let files = event.target.files;
            if (!files.length) {
                return;
            }
            library.showLoadingIndicator(this.wrapperID);
            if (files.length > 1) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                let message = 'Select no more than one file.';
                await library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeManagerImportError', preventCloseOnBackdropClick: true
                });
                library.hideLoadingIndicator(this.wrapperID);
                return;
            }
            if (files[0].size > (this.uploadMaxFilesize * 1024 * 1024)) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                let message = `The maximum file size limit is ${this.uploadMaxFilesize} Mb.`;
                await library.showDialog(message, false, false, {
                    title: title, name: 'vmsCustomAttributeManagerImportError', preventCloseOnBackdropClick: true
                });
                library.hideLoadingIndicator(this.wrapperID);
                return;
            }
            let file = files[0];
            let fileReader = new FileReader();
            let currentPsp = this.currentPsp();
            let currentGroupId = this.currentGroupId;
            let fileType = files[0].type === 'application/json' ? 'json' : 'csv';
            fileReader.onload = ((e) => {
                let content = e.target.result;
                this.importCustomAttributes(currentPsp, currentGroupId, content, fileType);
            });
            fileReader.readAsText(file);
        },
        async save() {
            let pspId = this.currentPsp();
            let currentGroupId = this.currentGroupId;
            let groupList = this.groupList;
            let attrList = this.attrList;
            let groupIds = [];
            let attrIds = [];
            if (pspId && currentGroupId && groupList.length) {
                library.showLoadingIndicator(this.wrapperID);
                groupList.forEach((item) => groupIds.push(item.groupID));
                attrList.forEach((item) => attrIds.push(item.attrID));
                let response = await this.saveOrdersCustomAttributes(pspId, currentGroupId, groupIds, attrIds);
                library.hideLoadingIndicator(this.wrapperID);
                if (response && response.status !== 'success' && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsCustomAttributeManagerSaveWarning', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                } else {
                    this.close();
                }
            } else {
                this.close();
            }
        },
        close() {
            if (/openvmsCustomAttributeManager/g.test(window.name)) {
                window.close();
            } else if (
                this.$parent
                && this.$parent.$parent
                && this.$parent.$parent.$parent
                && typeof this.$parent.$parent.$parent.componentDialogs === 'object'
                && this.$parent.$parent.$parent.componentDialogs.length
            ) {
                this.$parent.$parent.$parent.componentDialogs.find((component) => component.name === 'openvmsCustomAttributeManager')?.cancelButton?.click();
            }
        },
        // sDs
        async deleteCustomAttributeGroup(pspID, groupID) {
            let response = await this.sDs.post('ec_deleteCustomAttributeGroup', pspID, groupID);
            return response && response.status === 'success' && typeof response.data !== 'undefined';
        },
        async deleteCustomAttributes(pspID, groupID, attrIds) {
            let response = await this.sDs.post('ec_deleteCustomAttributes', pspID, groupID, attrIds);
            return response && response.status === 'success' && typeof response.data !== 'undefined';
        },
        async getCustomAttributeGroups(isCleanLocalAttrs = false) {
            this.currentGroupId = null;
            let pspID = this.currentPsp();
            if (!pspID) {
                this.groupList = [];
                return;
            }
            library.showLoadingIndicator(this.wrapperID);
            this.sDs.post('ec_getCustomAttributeGroups', pspID).then((response) => {
                if (response && response.status === 'success' && typeof response.data === 'object' && response.data) {
                    this.groupList = library.cloneObj(response.data);
                } else {
                    this.groupList = [];
                }
                if (isCleanLocalAttrs) {
                    this.currentAttrIds = [];
                    this.filterAttrList = [];
                }
                if (this.isGroupFiltering()) {
                    this.groupFilter();
                }
                library.hideLoadingIndicator(this.wrapperID);
            });
        },
        async getCustomAttributes() {
            let pspID = this.currentPsp();
            let currentGroupId = this.currentGroupId;
            if (!pspID || !currentGroupId) {
                return;
            }
            library.showLoadingIndicator(this.wrapperID);
            this.sDs.post('ec_getCustomAttributes', pspID, currentGroupId).then((response) => {
                if (response && response.status === 'success' && typeof response.data === 'object' && response.data) {
                    this.attrList = library.cloneObj(response.data);
                } else {
                    this.attrList = [];
                }
                if (this.isAttrFiltering()) {
                    this.attrFilter();
                }
                library.hideLoadingIndicator(this.wrapperID);
            });
        },
        async getCustomAttributeDependencies(pspID, groupID, attrIDs = null) {
            let response = await this.sDs.post('ec_getCustomAttributeDependencies', pspID, groupID, attrIDs, attrIDs === null);
            let dependencies = '';
            if (response && response.status === 'success' && typeof response.data === 'object' && response.data) {
                if (typeof response.data.automations === 'object' && response.data.automations.length) {
                    dependencies += `<div class='vmsCustomAttributeManager-dependencies'>Automation(s):${response.data.automations.map((item) => `<li>${item}</li>`).join('')}</div>`;
                }
                if (typeof response.data.activities === 'object' && response.data.activities.length) {
                    dependencies += `<div class='vmsCustomAttributeManager-dependencies'>Activities(s):${response.data.activities.map((item) => `<li>${item}</li>`).join('')}</div>`;
                }
                if (typeof response.data.filters === 'object' && response.data.filters.length) {
                    dependencies += `<div class='vmsCustomAttributeManager-dependencies'>Filter(s) and Prerequisite(s):${response.data.filters.map((item) => `<li>${item}</li>`).join('')}</div>`;
                }
                if (typeof response.data.components === 'object' && response.data.components.length) {
                    dependencies += `<div class='vmsCustomAttributeManager-dependencies'>DevDash component(s):${response.data.components.map((item) => `<li>${item}</li>`).join('')}</div>`;
                }
                if (typeof response.data.signin === 'object' && response.data.signin.length) {
                    dependencies += `<div class='vmsCustomAttributeManager-dependencies'>Sign In station(s):${response.data.signin.map((item) => `<li>${item}</li>`).join('')}</div>`;
                }
            }
            return dependencies;
        },
        async saveOrdersCustomAttributes(pspID, groupID, groupIDs, attrIDs) {
            return this.sDs.post('ec_saveOrdersCustomAttributes', pspID, groupID, groupIDs, attrIDs);
        },
        async exportCustomAttributeGroups(pspID, groupID, fileName, fileType = 'json') {
            if (fileType !== 'json' || fileType !== 'csv') {
                fileType = 'json';
            }
            let response = await this.sDs.post('ec_exportCustomAttributeGroups', pspID, groupID, fileType);
            if (
                (fileType === 'csv' && response && typeof response === 'string')
                || (fileType === 'json' && response && typeof response.status === 'undefined' && typeof response.error === 'undefined')
            ) {
                let data = typeof response === 'object' ? JSON.stringify(response) : response;
                let blob = new Blob([data], { type: fileType === 'json' ? 'application/json' : 'application/csv' });
                let downloadUrl = URL.createObjectURL(blob);
                let aElement = document.createElement('a');
                aElement.href = downloadUrl;
                aElement.download = (fileName ?? 'exportUDF') + '.' + fileType;
                aElement.click();
                URL.revokeObjectURL(downloadUrl);
            }
            return response;
        },
        async exportCustomAttributes(pspID, groupID, fileName, attrIDs, fileType = 'json') {
            if (fileType !== 'json' || fileType !== 'csv') {
                fileType = 'json';
            }
            let response = await this.sDs.post('ec_exportCustomAttributes', pspID, groupID, attrIDs, fileType);
            if (
                (fileType === 'csv' && response && typeof response === 'string')
                || (fileType === 'json' && response && typeof response.status === 'undefined' && typeof response.error === 'undefined')
            ) {
                let data = typeof response === 'object' ? JSON.stringify(response) : response;
                let blob = new Blob([data], { type: fileType === 'json' ? 'application/json' : 'application/csv' });
                let downloadUrl = URL.createObjectURL(blob);
                let aElement = document.createElement('a');
                aElement.href = downloadUrl;
                aElement.download = (fileName ?? 'exportUDF') + '.' + fileType;
                aElement.click();
                URL.revokeObjectURL(downloadUrl);
            }
            return response;
        },
        async importCustomAttributeGroups(importData, importFormat) {
            let response = await this.sDs.post('ec_importCustomAttributeGroups', importData, importFormat);
            if (response && typeof response.error === 'object' && response.error.length) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                library.showDialog(response.error[0], false, false, {
                    title: title, name: 'vmsCustomAttributeManagerImportError', preventCloseOnBackdropClick: true, showAsAlert: true
                });
            } else {
                let currentGroupId = this.currentGroupId;
                await this.getCustomAttributeGroups();
                if (currentGroupId) {
                    this.currentGroupId = currentGroupId;
                    await this.getCustomAttributes();
                }
            }
            library.hideLoadingIndicator(this.wrapperID);
        },
        async importCustomAttributes(pspID, groupID, importData, importFormat) {
            let response = await this.sDs.post('ec_importCustomAttributes', pspID, groupID, importData, importFormat);
            if (response && typeof response.error === 'object' && response.error.length) {
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                library.showDialog(response.error[0], false, false, {
                    title: title, name: 'vmsCustomAttributeManagerImportError', preventCloseOnBackdropClick: true, showAsAlert: true
                });
            } else if (this.currentGroupId) {
                await this.getCustomAttributes();
            }
            library.hideLoadingIndicator(this.wrapperID);
        },
        async copyCustomAttributeGroup(groupID) {
            return this.sDs.post('ec_copyCustomAttributeGroup', groupID);
        },
        async copyCustomAttributes(groupID, attrIDs) {
            return this.sDs.post('ec_copyCustomAttributes', groupID, attrIDs);
        },
    }
};

componentStore.initComponent(vmsCustomAttributeManagerCmp, vmsCustomAttributeManagerConfig);
export { vmsCustomAttributeManagerConfig, vmsCustomAttributeManagerCmp };
export default vmsCustomAttributeManagerCmp;
</script>

<style>
#dialog_container_openvmsCustomAttributeManager, #dialog_container_openvmsCustomAttributeManager > div {
    height: 400px;
}
.vmsCustomAttributeManager-dependencies {
    margin-top: 10px;
}
.vmsCustomAttributeManager-dependencies li {
    margin-left: 15px;
    margin-top: 5px;
}
.vmsCustomAttributeManager-itemId {
    color: #d3d3d3;
}
</style>
<style scoped>
:deep(.vmsCustomAttributeManager-title) {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
:deep(.vmsCustomAttributeManager-Wrapper) {
    display: flex;
}
:deep(.vmsCustomAttributeManager-mainWrapper) {
    margin-top: 20px;
    width: calc(50% - 10px);
    display: inline-block;
}
:deep(.vmsCustomAttributeManager-mainWrapper.__marginLeft) {
    margin-left: 10px;
}
:deep(.vmsCustomAttributeManager-mainWrapper.__marginRight) {
    margin-right: 10px;
}
:deep(.vmsCustomAttributeManager-recordType) {
    margin-left: 5px;
    width: 250px;
    display: inline-flex;
}
:deep(.vmsCustomAttributeManager-groupList-header) {
    background: #cfd8dc;
    padding: 5px;
    min-height: 30px;
    align-items: center;
    display: flex;
}
:deep(.vmsCustomAttributeManager-groupList-header span) {
    font-weight: bold;
    font-size: 13px;
    margin-left: 25px;
}
:deep(.vmsCustomAttributeManager-groupList-control) {
    height: 450px;
    overflow-y: auto;
}
:deep(.vmsCustomAttributeManager-groupList-control.__empty) {
    text-align: center;
    padding: 20px;
}
:deep(.vmsCustomAttributeManager-attrList-header) {
    background: #cfd8dc;
    padding: 5px;
    min-height: 30px;
    align-items: center;
    display: flex;
}
:deep(.vmsCustomAttributeManager-attrList-header .selectAll) {
    width: auto !important;
}
:deep(.vmsCustomAttributeManager-attrList-header span) {
    font-weight: bold;
    font-size: 13px;
    margin-left: 5px;
}
:deep(.vmsCustomAttributeManager-attrList-control) {
    height: 450px;
    overflow-y: auto;
}
:deep(.vmsCustomAttributeManager-attrList-control.__empty) {
    text-align: center;
    padding: 20px;
}
:deep(.vmsCustomAttributeManager-itemList) {
    width: 100%;
    min-height: 30px;
    padding: 5px;
    display: flex;
    font-weight: bolder;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid #dadce0;
}
:deep(.vmsCustomAttributeManager-itemList:hover) {
    background:#e8f0fe;
}
:deep(.vmsCustomAttributeManager-itemList-cell) {
    margin: 0 5px;
    display: inline-flex;
    align-items: center;
}
:deep(.vmsCustomAttributeManager-itemList-cell-whiteSpace) {
    width: 12px;
    margin-right: 10px;
}
:deep(.vmsCustomAttributeManager-itemList-cell-isActive) {
    width: 12px;
    height: 12px;
    background: #1976d2;
    border-radius: 50%;
}
:deep(.vmsCustomAttributeManager-wrapper) {
    width: 100%;
    height: 400px;
    background-color: #fff;
    padding: 20px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsCustomAttributeManager-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsCustomAttributeManager-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
:deep(.vmsCustomAttributeManager-inputUploadFiles) {
    display: none;
}
:deep(.vmsCustomAttributeManager-button.__control) {
    display: inline-block;
    margin-left: 20px;
    width: 130px;
}
</style>
